import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BACKBONE_URL, PAGE_RESULT_SIZE } from '../../shared/constants';
import { AzureNamespace, UpdateActiveStatusRequest, UpdateKeysRequest } from '../../shared/models/azure-namespaces.model';

@Injectable({
  providedIn: 'root'
})
export class AzureNamespacesService {

  constructor(private httpClient: HttpClient) { }

  public getRecordCounts() {
    const address = BACKBONE_URL + `AzureNamespaces/count`;
    return this.httpClient.get(address);
  }

  public getNamespaces(pageNo: number) {
    const address = BACKBONE_URL + `AzureNamespaces?page=${pageNo}&result=${PAGE_RESULT_SIZE}`;
    return this.httpClient.get(address);
  }

  public getNamespaceById(id: number) {
    const address = BACKBONE_URL + `AzureNamespaces/${id}`;
    return this.httpClient.get(address);
  }

  public getNamespacesByAccountId(accountId: number) {
    const address = BACKBONE_URL + `AzureNamespaces/get-by-account/${accountId}`;
    return this.httpClient.get(address);
  }

  public getEndpointsCount(id: number) {
    const address = BACKBONE_URL + `AzureNamespaces/get-endpoints-count/${id}`;
    return this.httpClient.get(address);
  }

  public createNamespace(model: AzureNamespace) {
    const address = `${BACKBONE_URL}AzureNamespaces`;
    return this.httpClient.post(address, model);
  }

  public updateNamespace(model: AzureNamespace) {
    const address = `${BACKBONE_URL}AzureNamespaces/${model.Id}`;
    return this.httpClient.put(address, model);
  }

  public deleteNamespace(id: number) {
    const address = `${BACKBONE_URL}AzureNamespaces/${id}`;
    return this.httpClient.delete(address);
  }

  public updateKeys(model: UpdateKeysRequest) {
    const address = BACKBONE_URL + `AzureNamespaces/update-keys/${model.id}`;
    return this.httpClient.put(address, model);
  }

  public updateActiveStatus(model: UpdateActiveStatusRequest) {
    const address = BACKBONE_URL + `AzureNamespaces/update-active-status/${model.id}`;
    return this.httpClient.put(address, model);
  }

}
